"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _formatMessage = _interopRequireDefault(require("../format-message"));

/*
 * Copyright (C) 2018 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */
var locale = {
  alternative_text_a834dcad: {
    message: "Kuputuhi rerek\u0113:"
  },
  announcement_list_da155734: {
    message: "R\u0101rangi P\u0101nuitanga"
  },
  announcements_a4b8ed4a: {
    message: "P\u0101nuitanga"
  },
  assignments_1e02582c: {
    message: "Ng\u0101 whakataunga"
  },
  background_color_press_down_to_select_ef99fdac: {
    message: "Tae Papamuri, ki te p\u0113hi ki raro t\u012Bpako"
  },
  c_2001_acme_inc_283f7f80: {
    message: "(c) 2001 Acme Inc."
  },
  cancel_file_upload_9903e7b9: {
    message: "Whakakore k\u014Dnae tukuake"
  },
  cancel_image_upload_2c771950: {
    message: "Whakakore \u0101hua tukuake"
  },
  cc_attribution_f6de631f: {
    message: "CC Tukunga"
  },
  cc_attribution_no_derivatives_b006744f: {
    message: "CC Tukunga Kaore ng\u0101 P\u0101r\u014Dnaki"
  },
  cc_attribution_non_commercial_39e0d30d: {
    message: "CC Tukunga Non-Commercial"
  },
  cc_attribution_non_commercial_no_derivatives_9fe74c00: {
    message: "CC Tukunga Non-Commercial kaore ng\u0101 p\u0101r\u014Dnaki"
  },
  cc_attribution_non_commercial_share_alike_c7edb1e5: {
    message: "CC Tukunga Non-Commercial tuari  Rite tonu"
  },
  cc_attribution_share_alike_669e7f16: {
    message: "CC Tukunga Tuari Rite"
  },
  check_if_the_image_is_decorative_283649b7: {
    message: "Tirohia m\u0113n\u0101 he whakapaipai te \u0101hua"
  },
  choose_usage_rights_33683854: {
    message: "K\u014Dwhiria ng\u0101 m\u014Dtika whakamahi ..."
  },
  click_any_file_to_insert_a_download_link_for_that__a708fa4c: {
    message: "P\u0101whiri t\u0113tahi k\u014Dnae ki te k\u014Dkuhu i t\u0113tahi hononga tikiake mo taua k\u014Dnae."
  },
  click_any_image_to_embed_the_image_in_the_page_2cdd1136: {
    message: "P\u0101whiri t\u0113tahi \u0101hua ki te whaka\u016B i te \u0101hua i roto i te wh\u0101rangi."
  },
  click_any_page_to_insert_a_link_to_that_page_ac920c02: {
    message: "P\u0101whiri t\u0113tahi wh\u0101rangi ki te k\u014Dkuhu i t\u0113tahi hono ki taua wh\u0101rangi."
  },
  click_to_embed_image_33107dd8: {
    message: "P\u0101whiritia ki te whaka\u016B i te \u0101hua"
  },
  click_to_embed_imagename_c41ea8df: {
    message: "P\u0101whiritia ki te whaka\u016B i { imageName }"
  },
  click_to_insert_a_link_into_the_editor_c19613aa: {
    message: "P\u0101whiritia ki te k\u014Dkuhu i t\u0113tahi hononga ki te \u0113tita"
  },
  click_to_insert_a_link_to_this_item_39794098: {
    message: "Pawhiritia ki te k\u014Dkuhu i te hono ki t\u0113nei t\u016Bemi"
  },
  close_flickr_form_b32e600a: {
    message: "Katia pukapuka Flickr"
  },
  collaborations_5c56c15f: {
    message: "tahi"
  },
  copyright_holder_66ee111: {
    message: "Kaimau Manat\u0101rua:"
  },
  course_navigation_dd035109: {
    message: "Whakaterenga Akoranga "
  },
  creative_commons_license_725584ae: {
    message: "Auaha ng\u0101 Raihana Noa:"
  },
  decorative_image_fde98579: {
    message: "Whakapaipai \u0101hua"
  },
  discussions_a5f96392: {
    message: "Ng\u0101 K\u014Drerorero"
  },
  discussions_index_6c36ced: {
    message: "Taup\u016B Ng\u0101 Matapaki"
  },
  embed_image_1080badc: {
    message: "T\u0101mau \u0100hua"
  },
  enter_search_terms_e397b1f0: {
    message: "tomo ng\u0101 kupu rapu"
  },
  enter_the_alternative_text_for_this_image_88047c47: {
    message: "Whakauru te kuputuhi rerek\u0113 mo t\u0113nei \u0101hua"
  },
  file_upload_form_4aaad554: {
    message: "K\u014Dnae Tukuake Pukapuka"
  },
  files_c300e900: {
    message: "K\u014Dnae"
  },
  files_index_af7c662b: {
    message: "Taup\u016B k\u014Dnae"
  },
  folder_705fd2d7: {
    message: "k\u014Dpaki"
  },
  font_size_press_down_to_select_6c25dc2d: {
    message: "Rahi Momo tuhi, ki te p\u0113hi ki raro t\u012Bpako"
  },
  formatting_press_down_to_select_df728c30: {
    message: "Whakah\u014Dputu, ki te p\u0113hi ki raro t\u012Bpako"
  },
  grades_a61eba0a: {
    message: "Ng\u0101 K\u014Deke"
  },
  group_navigation_99f191a: {
    message: "Whakaterenga r\u014Dp\u016B"
  },
  i_have_obtained_permission_to_use_this_file_6386f087: {
    message: "Kua whiwhi ahau whak\u0101etanga ki te whakamahi i t\u0113nei k\u014Dnae."
  },
  i_hold_the_copyright_71ee91b1: {
    message: "Mau ahau te manat\u0101rua"
  },
  if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5: {
    message: "Ki te kore koe e t\u012Bpako ng\u0101 m\u014Dtika whakamahi in\u0101ianei, kaore e whakaputaina t\u0113nei k\u014Dnae i muri o ''te tukuake."
  },
  image_upload_form_7b74079a: {
    message: "\u0100hua Tukuake Pukapuka"
  },
  images_7ce26570: {
    message: "Ng\u0101 \u0101hua"
  },
  insert_equella_links_49a8dacd: {
    message: "Whakauru ng\u0101 hononga Equella"
  },
  insert_link_6dc23cae: {
    message: "Whakauru hono"
  },
  insert_math_equation_57c6e767: {
    message: "Whakauru Math Wh\u0101rite"
  },
  link_7262adec: {
    message: "hono"
  },
  link_to_a_new_page_6c4ad034: {
    message: "Hono ki te Wh\u0101rangi H\u014Du"
  },
  link_to_other_content_in_the_course_879163b5: {
    message: "Hono atu ki t\u0113tahi atu ihirangi roto i te akoranga."
  },
  link_to_other_content_in_the_group_3fe25379: {
    message: "Hono atu ki t\u0113tahi atu ihirangi roto i te r\u014Dp\u016B."
  },
  link_to_url_52dd935c: {
    message: "Hono k\u012B URL"
  },
  links_14b70841: {
    message: "Hononga"
  },
  load_more_results_460f49a9: {
    message: "Te uta atu ng\u0101 hua"
  },
  loading_25990131: {
    message: "E Uta ana...."
  },
  loading_failed_b3524381: {
    message: "I rahua te uta"
  },
  loading_folders_8d4d5d5a: {
    message: "E uta ana i ng\u0101 k\u014Dpaki..."
  },
  modules_c4325335: {
    message: "k\u014Dwae"
  },
  no_results_940393cf: {
    message: "Kaore he hua"
  },
  pages_e5414c2c: {
    message: "Ng\u0101 wh\u0101rangi"
  },
  people_b4ebb13c: {
    message: "Ng\u0101 T\u0101ngata"
  },
  quizzes_7e598f57: {
    message: "Ng\u0101 Quizzes"
  },
  record_upload_media_5fdce166: {
    message: "T\u0101hopu/Kaweake P\u0101p\u0101ho"
  },
  rich_text_area_press_alt_f8_for_help_58f0f2c3: {
    message: "Horahanga Kupu Taunaki. P\u0113hi ALT + K8 mo te \u0101whina"
  },
  search_280d00bd: {
    message: "Rapu"
  },
  search_flickr_6884b518: {
    message: "Rapu Flickr"
  },
  select_a_file_53ba40ac: {
    message: "T\u012Bpako he k\u014Dnae"
  },
  select_a_folder_to_upload_your_file_into_b82d12b: {
    message: "T\u012Bpakohia he k\u014Dpaki hei tukuake i t\u014D konae ki roto"
  },
  syllabus_f191f65b: {
    message: "Marautanga"
  },
  text_color_press_down_to_select_8f5ad9b5: {
    message: "Tae Kuputuhi, ki te p\u0113hi ki raro t\u012Bpako"
  },
  the_material_is_in_the_public_domain_279c39a3: {
    message: "Ko te rauemi kei roto i te rohe t\u016Bmatanui"
  },
  the_material_is_licensed_under_creative_commons_3242cb5e: {
    message: "Raihanatia te rauemi i raro i te Auaha Noa"
  },
  the_material_is_subject_to_fair_use_exception_41bc6a4b: {
    message: "Ko te kaupapa ki te ataahua whakamahi okotahi te rauemi"
  },
  this_upload_exceeds_the_file_storage_quota_please__c3a1b641: {
    message: "Ko t\u0113nei tukunga ka nui ake i te kohinga rokiroki k\u014Dnae. T\u0113n\u0101 koa k\u014Drero ki t\u014D kaiwhakahaere p\u016Bnaha"
  },
  upload_8b403d05: {
    message: "Tukuake"
  },
  upload_a_new_file_96e6d4ff: {
    message: "Tukuake he k\u014Dnae hou"
  },
  upload_a_new_image_890df275: {
    message: "Tukuake i te \u0101hua hou"
  },
  usage_right_ff96f3e2: {
    message: "Tika mo te whakamahinga:"
  },
  what_would_you_like_to_call_the_new_page_d7e4488a: {
    message: "He aha t\u014D hiahia ki te karanga i te wh\u0101rangi hou?"
  },
  wiki_home_9cd54d0: {
    message: "Wiki Kainga"
  }
}; // no tinymce translations yet, will use english

_formatMessage.default.addLocale({
  mi: locale
});